"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Disposable = _interopRequireDefault(require("../Disposable.js"));

var _Event = _interopRequireDefault(require("./Event.js"));

var _functions = require("../functions.js");

var _obj = require("../obj.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/events/Target
 */


/**
 * @typedef {EventTarget|Target} EventTargetLike
 */

/**
 * @classdesc
 * A simplified implementation of the W3C DOM Level 2 EventTarget interface.
 * See https://www.w3.org/TR/2000/REC-DOM-Level-2-Events-20001113/events.html#Events-EventTarget.
 *
 * There are two important simplifications compared to the specification:
 *
 * 1. The handling of `useCapture` in `addEventListener` and
 *    `removeEventListener`. There is no real capture model.
 * 2. The handling of `stopPropagation` and `preventDefault` on `dispatchEvent`.
 *    There is no event target hierarchy. When a listener calls
 *    `stopPropagation` or `preventDefault` on an event object, it means that no
 *    more listeners after this one will be called. Same as when the listener
 *    returns false.
 */
var Target =
/** @class */
function (_super) {
  __extends(Target, _super);
  /**
   * @param {*} [opt_target] Default event target for dispatched events.
   */


  function Target(opt_target) {
    var _this = _super.call(this) || this;
    /**
     * @private
     * @type {*}
     */


    _this.eventTarget_ = opt_target;
    /**
     * @private
     * @type {Object<string, number>}
     */

    _this.pendingRemovals_ = null;
    /**
     * @private
     * @type {Object<string, number>}
     */

    _this.dispatching_ = null;
    /**
     * @private
     * @type {Object<string, Array<import("../events.js").Listener>>}
     */

    _this.listeners_ = null;
    return _this;
  }
  /**
   * @param {string} type Type.
   * @param {import("../events.js").Listener} listener Listener.
   */


  Target.prototype.addEventListener = function (type, listener) {
    if (!type || !listener) {
      return;
    }

    var listeners = this.listeners_ || (this.listeners_ = {});
    var listenersForType = listeners[type] || (listeners[type] = []);

    if (listenersForType.indexOf(listener) === -1) {
      listenersForType.push(listener);
    }
  };
  /**
   * Dispatches an event and calls all listeners listening for events
   * of this type. The event parameter can either be a string or an
   * Object with a `type` property.
   *
   * @param {import("./Event.js").default|string} event Event object.
   * @return {boolean|undefined} `false` if anyone called preventDefault on the
   *     event object or if any of the listeners returned false.
   * @api
   */


  Target.prototype.dispatchEvent = function (event) {
    var isString = typeof event === 'string';
    var type = isString ? event : event.type;
    var listeners = this.listeners_ && this.listeners_[type];

    if (!listeners) {
      return;
    }

    var evt = isString ? new _Event["default"](event) :
    /** @type {Event} */
    event;

    if (!evt.target) {
      evt.target = this.eventTarget_ || this;
    }

    var dispatching = this.dispatching_ || (this.dispatching_ = {});
    var pendingRemovals = this.pendingRemovals_ || (this.pendingRemovals_ = {});

    if (!(type in dispatching)) {
      dispatching[type] = 0;
      pendingRemovals[type] = 0;
    }

    ++dispatching[type];
    var propagate;

    for (var i = 0, ii = listeners.length; i < ii; ++i) {
      if ('handleEvent' in listeners[i]) {
        propagate =
        /** @type {import("../events.js").ListenerObject} */
        listeners[i].handleEvent(evt);
      } else {
        propagate =
        /** @type {import("../events.js").ListenerFunction} */
        listeners[i].call(this, evt);
      }

      if (propagate === false || evt.propagationStopped) {
        propagate = false;
        break;
      }
    }

    if (--dispatching[type] === 0) {
      var pr = pendingRemovals[type];
      delete pendingRemovals[type];

      while (pr--) {
        this.removeEventListener(type, _functions.VOID);
      }

      delete dispatching[type];
    }

    return propagate;
  };
  /**
   * Clean up.
   */


  Target.prototype.disposeInternal = function () {
    this.listeners_ && (0, _obj.clear)(this.listeners_);
  };
  /**
   * Get the listeners for a specified event type. Listeners are returned in the
   * order that they will be called in.
   *
   * @param {string} type Type.
   * @return {Array<import("../events.js").Listener>|undefined} Listeners.
   */


  Target.prototype.getListeners = function (type) {
    return this.listeners_ && this.listeners_[type] || undefined;
  };
  /**
   * @param {string} [opt_type] Type. If not provided,
   *     `true` will be returned if this event target has any listeners.
   * @return {boolean} Has listeners.
   */


  Target.prototype.hasListener = function (opt_type) {
    if (!this.listeners_) {
      return false;
    }

    return opt_type ? opt_type in this.listeners_ : Object.keys(this.listeners_).length > 0;
  };
  /**
   * @param {string} type Type.
   * @param {import("../events.js").Listener} listener Listener.
   */


  Target.prototype.removeEventListener = function (type, listener) {
    var listeners = this.listeners_ && this.listeners_[type];

    if (listeners) {
      var index = listeners.indexOf(listener);

      if (index !== -1) {
        if (this.pendingRemovals_ && type in this.pendingRemovals_) {
          // make listener a no-op, and remove later in #dispatchEvent()
          listeners[index] = _functions.VOID;
          ++this.pendingRemovals_[type];
        } else {
          listeners.splice(index, 1);

          if (listeners.length === 0) {
            delete this.listeners_[type];
          }
        }
      }
    }
  };

  return Target;
}(_Disposable["default"]);

var _default = Target;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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